export default [
  { to: '/test/fusebox', display: 'Tests varios' },
  { to: '/test/perceptualhash', display: 'Perceptual hash' },
  { to: '/test/embedding', display: 'Fusebox cluster embedding' },
  { to: '/test/embed-similarity', display: 'Top Global Fbox similarity' },
  { to: '/test/fusebox-dataset-review', display: 'Fusebox dataset review' },
  { to: '/test/fusebox-embedding-benchmark', display: 'Fusebox embedding benchmark' },
  { to: '/test/fusebox-clusters-links', display: 'Fusebox cluster links' },
  // { to: '/crawl/models', display: 'Models' },
];
